import { Separator } from "@/components/ui/separator"
import { withIva } from "@/lib/tax"
import { FormCheckboxField } from "@/components/ui/form-checkbox-field"
import { FormInputField } from "@/components/ui/form-input-field"

import type { ProductFieldGroupProps } from "./product-field-types"

interface ProductPricingFieldsProps extends ProductFieldGroupProps {
  price: number
  isTaxable: boolean
}

export function ProductPricingFields({
  control,
  labels,
  price,
  isTaxable,
}: ProductPricingFieldsProps) {
  return (
    <div className="space-y-6">
      <div className="flex items-center gap-4">
        <span className="text-sm font-black uppercase tracking-widest text-muted-foreground/60">
          {labels.pricesLabel}
        </span>
        <Separator className="flex-1" />
      </div>

      <div className="grid grid-cols-1 gap-6 sm:grid-cols-2">
        <div className="space-y-2">
          <FormInputField
            control={control}
            name="unitCost"
            label={labels.unitCost + " *"}
            type="number"
            placeholder="0.00"
          />
          <p className="text-xs text-muted-foreground">{labels.unitCostDesc}</p>
        </div>
        <div className="space-y-2">
          <FormInputField
            control={control}
            name="price"
            label={labels.price + " *"}
            type="number"
            placeholder="0.00"
          />
          <p className="text-xs text-muted-foreground">{labels.priceDesc}</p>
        </div>
      </div>

      <div className="flex items-center justify-between rounded-md border border-input px-4 py-3">
        <FormCheckboxField control={control} name="isTaxable" label={labels.taxableLabel} />
        <span className="text-sm text-muted-foreground">{labels.taxableDesc}</span>
      </div>

      {isTaxable && (
        <div className="border-l-2 border-primary bg-primary/5 p-6 transition-all animate-in fade-in slide-in-from-left-4">
          <p className="mb-2 text-xs font-black uppercase tracking-widest text-primary/60">
            {labels.totalPriceIncVat}
          </p>
          <p className="font-display text-5xl leading-none tracking-tighter text-primary">
            ${withIva(Number(price)).toFixed(2)}
          </p>
        </div>
      )}
    </div>
  )
}
